import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid } from 'src/components';
import Paper from 'src/components/Paper';
import BaseComponent from 'src/core/base.component';
import HastalikList from './HastalikList';
import { translate } from 'src/i18n/tHelper';
import HastalikTaniList from './HastalikTaniList';
import HastalikTaniIslem from './HastalikTaniIslem';

interface IHastalikTanimProps {}
const path = 'pages|hataliktanim';

const HastalikTanim = (props: IHastalikTanimProps): JSX.Element => {

  return (
    <BaseComponent>
      <Helmet>{translate(path,"Hastalık Tanım Bilgileri")}</Helmet>
      <Grid container>
        <Grid item md={2.5}>
          <Paper header={translate(path, 'Hastalık Listesi')}>
            <HastalikList />
          </Paper>
        </Grid>
        <Grid item md={3.5}>
          <Paper header={translate(path, 'Hastalık Tanı Listesi')}>
            <HastalikTaniList />
          </Paper>
        </Grid>
        <Grid item md={6}>
          <Paper header={translate(path, 'Hastalık İşlem Listesi')}>
            <HastalikTaniIslem />
          </Paper>
        </Grid>
      </Grid>
    </BaseComponent>
  );
};

export default HastalikTanim;
